module.exports = __webpack_public_path__ + "img/grp-part-9-map.d4de061b.png";